export default "__VITE_ASSET__edoPmRrn__"